import { AvgBgpUpdateRateSubscription } from "../../graphql/generated/operations";

/**
 * @param {AvgBgpUpdateRateSubscription | undefined} data
 * @returns {number | undefined}
 */
export const formatter = (data) => data?.avgBGPUpdateRate[0]?.value;
